import $inoe from "@/config";
import db from "@/db";
import { CLOSE_LOADING, RootState, SHOW_LOADING } from "@/store/types";
import { Action, ActionTree } from "vuex";
import { ParametresState, PRAMATRES_STORE as s } from "./type";


export const savePointage: Action<ParametresState, RootState> = ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      dispatch(SHOW_LOADING, null, { root: true });
  
      // Helper function to filter documents
      const getFilteredDocs = (list: any, keyPrefix: string, isInoeFilter: boolean) => {
        return list.rows
          .filter((row: any) => row.doc.isInoe === isInoeFilter && row.id.startsWith(keyPrefix))
          .map((row: any) => row.doc);
      };
  
      Promise.all([
        db.localDB.allDocs({
          include_docs: true,
          attachments: true,
          startkey: "pointageAN",
          endkey: "pointageAN" + "\uffff",
        }),
        db.localDB.allDocs({
          include_docs: true,
          attachments: true,
          startkey: "supplementAN",
          endkey: "supplementAN" + "\uffff",
        }),
      ])
        .then(([listPointage, listSupplement]: [any, any]) => {
          const filteredPointage = getFilteredDocs(listPointage, "pointageAN", false);
          const filteredSupplement = getFilteredDocs(listSupplement, "supplementAN", false);
  
          const dataToResolve = {
            backup: JSON.stringify(filteredPointage),
            supplementRows: JSON.stringify(filteredSupplement),
          };
  
          resolve(dataToResolve);
          dispatch(CLOSE_LOADING, null, { root: true });
        })
        .catch((error) => {
          console.error("Error fetching documents:", error);
          reject(error);
        });
    });
  };
  
export const deleteMobi: Action<ParametresState, RootState> = ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
        dispatch(SHOW_LOADING, null, { root: true });
        db.localDB
            .destroy()
            .then(() => {
                $inoe.clearAll();
                (window as any).top.location.replace("/");
                resolve("done")
            })
            .catch((err: any) => {
                console.error(err);
            })
            .finally(() => {
                dispatch(CLOSE_LOADING, null, { root: true });
            });
    })
};
export const getLastSync: Action<ParametresState, RootState> = ({ commit }) => {
    return new Promise((resolve, reject) => {
        db.localDB
            .get("dateExport")
            .then((rep: any) => {
                commit(s.SET_LAST_SYNC, rep.lastExport);
            })
            .catch(() => {
                commit(s.SET_LAST_SYNC, "Aucune information");
            }).finally(() => resolve("DONE"))
    })
};

export const detectServerMigration: Action<ParametresState, RootState> = ({ commit }, payload?: { currentCluster?: string }) => {
    return new Promise((resolve, reject) => {
        const currentCluster = payload && payload.currentCluster ? payload.currentCluster : "c1";
        // Récupérer le cluster stocké dans le document "version" en localDB (previous)
        db.localDB
            .get("version")
            .then((localDoc: any) => {
                // Si cluster vide/absent, on suppose "c1" (défaut historique)
                const storedCluster = localDoc.cluster || "c1";

                if (storedCluster !== currentCluster) {
                    console.warn(`Migration serveur détectée: cluster ${storedCluster} → ${currentCluster}`);
                    resolve({
                        migrationDetected: true,
                        previousCluster: storedCluster,
                        currentCluster: currentCluster
                    });
                } else {
                    resolve({
                        migrationDetected: false,
                        cluster: currentCluster
                    });
                }
            })
            .catch(() => {
                // Pas de document local, première installation
                resolve({
                    migrationDetected: false,
                    error: "Première installation"
                });
            });
    })
};

// NOTE: La détection de migration serveur utilise le cluster courant retourné par l’API R

export const forceCompleteResync: Action<ParametresState, RootState> = ({ commit }, payload?: { currentCluster?: string }) => {
    return new Promise((resolve, reject) => {
        const currentCluster = payload && payload.currentCluster ? payload.currentCluster : undefined;
        // Fonction pour obtenir date - 7 jours
        const getDate7DaysAgo = () => {
            const date = new Date();
            date.setDate(date.getDate() - 7);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        
        // APRÈS migration de cluster, FORCER lastExport = date-7 jours pour re-tirer TOUS les docs
        // Ne PAS utiliser la date du serveur c3 car c'est la première connexion à ce cluster
        const fallbackDate = getDate7DaysAgo();
        console.warn("Migration: reset lastExport à", fallbackDate, "pour forcer re-sync complet");
        
        // Mettre à jour le document local avec la nouvelle date
        db.localDB
            .get("dateExport")
            .then((localDoc: any) => {
                // Vérifier si remoteDB est disponible (mode online)
                if (!db.remoteDB) {
                    console.warn("forceCompleteResync: Mode offline détecté, skip sync remote dateExport");
                    return db.localDB.put(localDoc);
                }
                
                return db.remoteDB.get("dateExport")
                    .then((remoteDoc: any) => {
                        localDoc.lastExport = remoteDoc && remoteDoc.lastExport ? remoteDoc.lastExport : null;
                        return db.localDB.put(localDoc);
                    })
                    .catch((err: any) => {
                        console.warn("dateExport remote introuvable, lastExport laissé tel quel:", err);
                        return db.localDB.put(localDoc);
                    });
            })
            .then(() => {
                if (currentCluster) {
                    db.localDB
                        .get("version")
                        .then((versionDoc: any) => {
                            versionDoc.cluster = currentCluster;
                            return db.localDB.put(versionDoc);
                        })
                        .catch((err: any) => {
                            console.warn("Cluster local non mis à jour:", err);
                        });
                }
                console.warn("Migration: lastExport = null, prêt pour re-sync complet");
                resolve("Resync complète initiée");
            })
            .catch((err: any) => {
                console.error("Erreur lors de la mise à jour locale:", err);
                reject(err);
            });
    })
};

export const fetchMobiVersion: Action<ParametresState, RootState> = ({ commit }) => {
    return new Promise((resolve, reject) => {
        db.localDB
            .get("version").then((resp: any) => {
                console.log("versionMobi", resp.versionMobi);
                commit(s.SET_MOBI_VERSION, resp.versionMobi);
                resolve("done");
            }).catch(() => {
                commit(s.SET_MOBI_VERSION, "v2.0");
                resolve("done");
            })
    })
};
export const upgrade: Action<ParametresState, RootState> = ({ commit,dispatch }) => {
console.log("upgrade")
  return new Promise((resolve, reject) => {
        dispatch(SHOW_LOADING, null, { root: true });
        db.localDB
            .destroy()
            .then(() => {
               // $inoe.clearAll();
               // (window as any).top.location.replace("/");
               dispatch("session/register", {
                dossier: $inoe.getDossier(),
                accesskey: $inoe.getAccessKey(),
                username: $inoe.getUsername(),
                cluster: $inoe.getUpgrade().cluster
                }, {root:true})
                resolve("done")
            })
            .catch((err: any) => {
                console.error(err);
            })
            .finally(() => {
                dispatch(CLOSE_LOADING, null, { root: true });
            });
    })
}
export const fetchPointagesLocal: Action<ParametresState, RootState> = ({ commit, dispatch }) => {
 return new Promise((resolve, reject) => {
    
     // Pas de connexion à la base distante, on fait quand même la connexion à la base locale
            db.localDB.allDocs({
                include_docs: true,
                startkey: "pointageAN",
                endkey: "supplementAN" + "\uffff",
            })
            .then((listLocalPointagesDocs: any) => {
                let docIds: any[]=[];
                let localPointagesfalse = 0
                let localSupplementsfalse = 0
                let localPointagesfalseOthers = 0
                let localSupplementsfalseOthers = 0
                // console.log("POUCH DB locale: ", listLocalPointagesDocs)
                listLocalPointagesDocs.rows.forEach((rpd: any)=>{
               
                    if(rpd.doc.typedoc === "pointageANMobi"){
                        if(!rpd.doc.isInoe){                         
                            if(rpd.doc.username === $inoe.getUsername()) {
                                localPointagesfalse++
                                docIds.push(rpd.doc._id);
                            }
                            localPointagesfalseOthers++
                        }
                    }
                    if(rpd.doc.typedoc === "supplementANMobi"){
                        if(!rpd.doc.isInoe){
                            if(rpd.doc.username === $inoe.getUsername()) {
                                localSupplementsfalse++
                                docIds.push(rpd.doc._id);
                            }
                            localSupplementsfalseOthers++
                        }
                    }
                })
                commit(s.SET_LOCAL_POINTAGE_FALSE, localPointagesfalse);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE, localSupplementsfalse);
              
                console.log(localPointagesfalse)
                  console.log(localSupplementsfalse)
                 console.log(docIds)
                 
                // Vérifier si remoteDB existe avant d'y accéder (mode offline)
                if (!db.remoteDB) {
                    console.warn("remoteDB non disponible (mode offline) - skip upgrade check");
                    commit(s.SET_UPGRADE, "offline");
                } else {
                  db.remoteDB.allDocs({
                    keys: docIds,
                    include_docs: false
                    }).then(function (result:any) {
                    let canUpgrade=true;
                    result.rows.forEach((row:any) => {
                        if (row.error === 'not_found') {
                        console.log(`${row.key} is NOT present on CouchDB`);
                         canUpgrade=false;
                        } else {
                        console.log(`${row.key} is present on CouchDB`);                        
                        }                       
                    });
                    if(canUpgrade){
                             commit(s.SET_UPGRADE, "upgrading")
                              dispatch("upgrade", null, { root: false });
                    }else{
                        //
                        commit(s.SET_UPGRADE, "cannot")
                    }
                  }).catch((err: any) => {
                    console.warn("Erreur vérification upgrade:", err);
                    commit(s.SET_UPGRADE, "error");
                  });
                }
                 
                // if(localPointagesfalse==0 && localSupplementsfalse==0){
                //     dispatch("upgrade", null, { root: false });
                // }
               
                resolve("Done")
            })
            resolve("Failed");
        })

}

export const fetchPointages: Action<ParametresState, RootState> = ({ commit }) => {
    var startTime = new Date();
    return new Promise((resolve, reject) => {
        // Vérifier si remoteDB existe avant d'y accéder (mode offline)
        if (!db.remoteDB) {
            console.warn("remoteDB non disponible (mode offline) - skip fetchPointages");
            resolve("offline-mode");
            return;
        }
        
        db.remoteDB.allDocs({
            include_docs: true,
            startkey: "pointageAN",
            endkey: "supplementAN" + "\uffff",
        })
        .then((listRemotePointagesDocs: any) => {
            let remotePointagesfalse = 0;
            let remoteSupplementsfalse = 0;
            let remotePointagesTrueOthers = 0;
            let remotePointagesfalseOthers = 0;
            let remoteSupplementsTrueOthers = 0;
            let remoteSupplementsfalseOthers = 0;
            // console.log("POUCH DB remote: ", listRemotePointagesDocs)
            listRemotePointagesDocs.rows.forEach((rpd: any)=>{
                if(rpd.doc.typedoc === "pointageANMobi"){
                    if(!rpd.doc.isInoe){
                        if(rpd.doc.username === $inoe.getUsername()) {
                            remotePointagesfalse++
                        }
                        remotePointagesfalseOthers++
                    } else {
                        remotePointagesTrueOthers++
                    }
                } else if(rpd.doc.typedoc === "supplementANMobi"){
                    if(!rpd.doc.isInoe){
                        if(rpd.doc.username === $inoe.getUsername()){
                                remoteSupplementsfalse++
                        }
                        remoteSupplementsfalseOthers++
                    } else {remoteSupplementsTrueOthers++}
                }
            })
            commit(s.SET_REMOTE_POINTAGE_FALSE, remotePointagesfalse);
            commit(s.SET_REMOTE_SUPPLEMENTS_FALSE, remoteSupplementsfalse);

            commit(s.SET_REMOTE_POINTAGE_FALSE_OTHERS, remotePointagesfalseOthers);
            commit(s.SET_REMOTE_POINTAGE_TRUE_OTHERS, remotePointagesTrueOthers);
            commit(s.SET_REMOTE_SUPPLEMENTS_FALSE_OTHERS, remoteSupplementsfalseOthers);
            commit(s.SET_REMOTE_SUPPLEMENTS_TRUE_OTHERS, remoteSupplementsTrueOthers);
            
            db.localDB.allDocs({
                include_docs: true,
                startkey: "pointageAN",
                endkey: "supplementAN" + "\uffff",
            })
            .then((listLocalPointagesDocs: any) => {
                let localPointagesfalse = 0
                let localSupplementsfalse = 0
                let localPointagesfalseOthers = 0
                let localSupplementsfalseOthers = 0
                // console.log("POUCH DB locale: ", listLocalPointagesDocs)
                listLocalPointagesDocs.rows.forEach((rpd: any)=>{
                    if(rpd.doc.typedoc === "pointageANMobi"){
                        if(!rpd.doc.isInoe){
                            if(rpd.doc.username === $inoe.getUsername()) {
                                localPointagesfalse++
                            }
                            localPointagesfalseOthers++
                        }
                    }
                    if(rpd.doc.typedoc === "supplementANMobi"){
                        if(!rpd.doc.isInoe){
                            if(rpd.doc.username === $inoe.getUsername()) {
                                localSupplementsfalse++
                            }
                            localSupplementsfalseOthers++
                        }
                    }
                })
                commit(s.SET_LOCAL_POINTAGE_FALSE, localPointagesfalse);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE, localSupplementsfalse);

                commit(s.SET_LOCAL_POINTAGE_FALSE_OTHERS, localPointagesfalseOthers);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS, localSupplementsfalseOthers);
                var datefin = new Date();
                var delta: number = datefin.getTime() - startTime.getTime();
                console.log("delta: ", delta)
                resolve("Done")
            }).catch(() => {
                commit(s.SET_LOCAL_POINTAGE_FALSE, -1);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE, -1);

                commit(s.SET_LOCAL_POINTAGE_FALSE_OTHERS, -1);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS, -1);
                resolve("Failed");
            })
        }).catch(() => {
            commit(s.SET_REMOTE_POINTAGE_FALSE, -1);
            commit(s.SET_REMOTE_SUPPLEMENTS_FALSE, -1);
            
            commit(s.SET_REMOTE_POINTAGE_FALSE_OTHERS, -1);
            commit(s.SET_REMOTE_POINTAGE_TRUE_OTHERS, -1);
            commit(s.SET_REMOTE_SUPPLEMENTS_FALSE_OTHERS, -1);
            commit(s.SET_REMOTE_SUPPLEMENTS_TRUE_OTHERS, -1);
            // Pas de connexion à la base distante, on fait quand même la connexion à la base locale
            db.localDB.allDocs({
                include_docs: true,
                startkey: "pointageAN",
                endkey: "supplementAN" + "\uffff",
            })
            .then((listLocalPointagesDocs: any) => {
                let localPointagesfalse = 0
                let localSupplementsfalse = 0
                let localPointagesfalseOthers = 0
                let localSupplementsfalseOthers = 0
                // console.log("POUCH DB locale: ", listLocalPointagesDocs)
                listLocalPointagesDocs.rows.forEach((rpd: any)=>{
                    if(rpd.doc.typedoc === "pointageANMobi"){
                        if(!rpd.doc.isInoe){
                            if(rpd.doc.username === $inoe.getUsername()) {
                                localPointagesfalse++
                            }
                            localPointagesfalseOthers++
                        }
                    }
                    if(rpd.doc.typedoc === "supplementANMobi"){
                        if(!rpd.doc.isInoe){
                            if(rpd.doc.username === $inoe.getUsername()) {
                                localSupplementsfalse++
                            }
                            localSupplementsfalseOthers++
                        }
                    }
                })
                commit(s.SET_LOCAL_POINTAGE_FALSE, localPointagesfalse);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE, localSupplementsfalse);

                commit(s.SET_LOCAL_POINTAGE_FALSE_OTHERS, localPointagesfalseOthers);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS, localSupplementsfalseOthers);
                var datefin = new Date();
                var delta: number = datefin.getTime() - startTime.getTime();
                console.log("delta: ", delta)
                resolve("Done")
            }).catch(() => {
                commit(s.SET_LOCAL_POINTAGE_FALSE, -1);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE, -1);

                commit(s.SET_LOCAL_POINTAGE_FALSE_OTHERS, -1);
                commit(s.SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS, -1);
                resolve("Failed");
            })
            resolve("Failed");
        })
    })
};

export const fetchAll: Action<ParametresState, RootState> = ({ dispatch, rootGetters }) => {
    return new Promise((resolve, reject) => {
        let listPromise: Array<Promise<any>> = [];
        listPromise.push(dispatch("fetchMobiVersion"));
        listPromise.push(dispatch("getLastSync"));
        listPromise.push(dispatch("moncompte/getInfoDossier", {}, { root: true }));
        //listPromise.push(dispatch("fetchPointages"));
        Promise.all(listPromise).then((rep: any) => {
            resolve('promiseall done')
        }).catch((error: any) => {
            console.log("error", error)
            reject(error)
        })
    })
}
export const clearAll: Action<ParametresState, RootState> = ({ commit }) => {
    commit(s.SET_LOCAL_POINTAGE_FALSE, -1);
    commit(s.SET_LOCAL_SUPPLEMENTS_FALSE, -1);

    commit(s.SET_LOCAL_POINTAGE_FALSE_OTHERS, -1);
    commit(s.SET_LOCAL_SUPPLEMENTS_FALSE_OTHERS, -1);
    commit(s.SET_REMOTE_POINTAGE_FALSE, -1);
    commit(s.SET_REMOTE_SUPPLEMENTS_FALSE, -1);

    commit(s.SET_REMOTE_POINTAGE_FALSE_OTHERS, -1);
    commit(s.SET_REMOTE_POINTAGE_TRUE_OTHERS, -1);
    commit(s.SET_REMOTE_SUPPLEMENTS_FALSE_OTHERS, -1);
    commit(s.SET_REMOTE_SUPPLEMENTS_TRUE_OTHERS, -1);

    commit(s.SET_LAST_SYNC, "Aucune information");
    commit(s.SET_MOBI_VERSION, "v3.0");
}
export const actions: ActionTree<ParametresState, RootState> = {
    savePointage,
    deleteMobi,
    getLastSync,
    fetchMobiVersion,
    fetchPointages,
    fetchPointagesLocal,
    upgrade,
    fetchAll,
    clearAll,
    detectServerMigration,
    forceCompleteResync
}
